import ScrollMagic from 'helpers/importers/ScrollMagic';
import setHash from 'helpers/setHash';

export default function addScenesForHash (c) {
  let hash1 = new ScrollMagic.Scene({
    triggerElement: '#header',
    offset: 0,
    duration: 0,
    triggerHook: 'onLeave',
  });

  let hash2 = new ScrollMagic.Scene({
    triggerElement: '#franchises',
    offset: -80,
    duration: 0,
    triggerHook: 'onLeave',
  });

  let hash3 = new ScrollMagic.Scene({
    triggerElement: '#studio',
    offset: -80,
    duration: 0,
    triggerHook: 'onLeave',
  });

  let hash31 = new ScrollMagic.Scene({
    triggerElement: '#slider',
    offset: -80,
    duration: 0,
    triggerHook: 'onLeave',
  });

  let hash32 = new ScrollMagic.Scene({
    triggerElement: '#meet-team',
    offset: -80,
    duration: 0,
    triggerHook: 'onLeave',
  });

  let hash33 = new ScrollMagic.Scene({
    triggerElement: '#pictures',
    offset: -80,
    duration: 0,
    triggerHook: 'onLeave',
  });


  let hash4 = new ScrollMagic.Scene({
    triggerElement: '#history',
    offset: -80,
    duration: 0,
    triggerHook: 'onLeave',
  });

  let hash5 = new ScrollMagic.Scene({
    triggerElement: '#careers',
    offset: -80,
    duration: 0,
    triggerHook: 'onLeave',
  });

  let hash6 = new ScrollMagic.Scene({
    triggerElement: '#news',
    offset: -80,
    duration: 0,
    triggerHook: 'onLeave',
  });

  hash1.on('start', _e => {
    setHash('#');
  });

  hash2.on('start', e => {
    if (e.scrollDirection !== 'REVERSE') {
      setHash('#franchises');
    } else {
      setHash('#');
    }
  });

  hash3.on('start', e => {
    if (e.scrollDirection !== 'REVERSE') {
      setHash('#studio');
    } else {
      setHash('#franchises');
    }
  });

  hash31.on('start', e => {
    if (e.scrollDirection !== 'REVERSE') {
      setHash('#slider');
    } else {
      setHash('#studio');
    }
  });

  hash32.on('start', e => {
    if (e.scrollDirection !== 'REVERSE') {
      setHash('#meet-team');
    } else {
      setHash('#slider');
    }
  });

  hash33.on('start', e => {
    if (e.scrollDirection !== 'REVERSE') {
      setHash('#pictures');
    } else {
      setHash('#meet-team');
    }
  });


  hash4.on('start', e => {
    if (e.scrollDirection !== 'REVERSE') {
      setHash('#history');
    } else {
      setHash('#studio');
    }
  });

  hash5.on('start', e => {
    if (e.scrollDirection !== 'REVERSE') {
      setHash('#careers');
    } else {
      setHash('#history');
    }
  });

  hash6.on('start', e => {
    if (e.scrollDirection !== 'REVERSE') {
      setHash('#news');
    } else {
      setHash('#careers');
    }
  });

  hash1.addTo(c);
  hash2.addTo(c);
  hash3.addTo(c);
  hash31.addTo(c);
  hash32.addTo(c);
  hash33.addTo(c);
  hash4.addTo(c);
  hash5.addTo(c);
  hash6.addTo(c);
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/scenes/addScenesForHash.js